import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { batchRequest } from '../../api/ApiService';
import { changeLocation } from '../../api/Location';
import Auth from '../../routes/Auth';

import { Loader } from 'react-loaders';

import Navigation from '../components/performance-feedback/components/navigation';
import Pagination from '../components/performance-feedback/components/pagination';

import ResultsAreInStep1 from '../components/performance-feedback/pages/results-are-in/step1';
import ResultsAreInStep2 from '../components/performance-feedback/pages/results-are-in/step2';

import SuccessfulStep1 from '../components/performance-feedback/pages/successful-teams/step1';
import SuccessfulStep2 from '../components/performance-feedback/pages/successful-teams/step2';
import SuccessfulStep3 from '../components/performance-feedback/pages/successful-teams/step3';

import WhyTargetsWerentHit from '../components/performance-feedback/pages/why-targets-werent-hit';

import DecisionsNotSubmitted from '../components/performance-feedback/pages/why-targets-werent-hit/decisions-not-submitted';
import InsufficientCapital from '../components/performance-feedback/pages/why-targets-werent-hit/insufficient-capital';

// import MarketShareStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step1';
import MarketShareStep2 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step2';
import MarketShareStep3 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step3';
import MarketShareStep4 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step4';
import MarketShareStep5 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step5';
import MarketShareStep6 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step6';
import MarketShareStep7 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step7';
//import MarketShareStep8 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step8';
import MarketShareStep9 from '../components/performance-feedback/pages/why-targets-werent-hit/market-share/step9';

// import RevenuesStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/revenues/step1';
import RevenuesStep2 from '../components/performance-feedback/pages/why-targets-werent-hit/revenues/step2';
import RevenuesStep3 from '../components/performance-feedback/pages/why-targets-werent-hit/revenues/step3';

// import GrossMarginsStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/gross-margins/step1';
import GrossMarginsStep2 from '../components/performance-feedback/pages/why-targets-werent-hit/gross-margins/step2';
import GrossMarginsStep3 from '../components/performance-feedback/pages/why-targets-werent-hit/gross-margins/step3';

// import SharePriceStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/share-price/step1';
import SharePriceStep2 from '../components/performance-feedback/pages/why-targets-werent-hit/share-price/step2';

import NetLoss from '../components/performance-feedback/pages/why-targets-werent-hit/net-loss';

// import ROEStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/roe/step1';
import ROEStep2 from '../components/performance-feedback/pages/why-targets-werent-hit/roe/step2';

// import ROAStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/roa/step1';
import ROAStep2 from '../components/performance-feedback/pages/why-targets-werent-hit/roa/step2';

// import EPSStep1 from '../components/performance-feedback/pages/why-targets-werent-hit/eps/step1';
import EPSStep2 from '../components/performance-feedback/pages/why-targets-werent-hit/eps/step2';

import WhatToExpectNext from '../components/performance-feedback/pages/what-to-expect-next';
import SupplyChainDecisions from '../components/performance-feedback/pages/what-to-expect-next/supply-chain-decisions';
import CustomerPreferences from '../components/performance-feedback/pages/what-to-expect-next/customer-preferences';
import ProductStrategy from '../components/performance-feedback/pages/what-to-expect-next/product-strategy';
import NewScoringMetrics from '../components/performance-feedback/pages/what-to-expect-next/new-scoring-metrics';
import NewValuationModel from '../components/performance-feedback/pages/what-to-expect-next/new-valuation-model';
import ShareBuybacks from '../components/performance-feedback/pages/what-to-expect-next/share-buybacks';

import ThatsAll from '../components/performance-feedback/pages/thats-all';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  background: #f5f6f7;

  .loader {
    display: inline-block;
    margin-top: 20px;
    margin-left: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 80%;
  max-width: 794px;
  background: #f5f6f7;
`;

// Empty state shown when the active round hasn't closed yet. Replaces
// the full page (sidebar nav + content) so the instructor doesn't see
// provisional data that would change once the round actually closes.
const EmptyState = styled.div`
  flex: 1;
  align-self: stretch;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #f5f6f7;
  text-align: center;
  font-family: 'Mukta Vaani', sans-serif;
`;

const EmptyStateTitle = styled.h2`
  margin: 0 0 12px;
  color: #0F172A;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
`;

const EmptyStateSubtext = styled.p`
  margin: 0;
  color: #475569;
  font-size: 16px;
  line-height: 1.5;
  max-width: 480px;
`;

class InstructorPerformanceFeedback extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      currentCategory: 0,
      currentStep: 0,
      navigation: [],
      loaded: false,
      teamGradings: [],
      teamGradingsLength: 0,
      overallStats: null,
      successfulTeamsCount: 0,
      gamesTargets: [],
      performanceFeedbacksGame: [],
      round: {},
      roundId: 0
    };
  }

  componentWillMount() {
    const { rounds } = this.props;
    const activeRound = this.activeRound;
    const round = rounds.find(i => Number(i.number) === Number(activeRound));

    const roundId = round ? round.id : 0;
    this.setState({
      round,
      roundId
    });
  }

  componentDidMount() {
    if (this.state.roundId) {
      this.loadNavigation(() => {
        this.updateCurrentState();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.rounds.length > 0 && !this.state.roundId) {
      const activeRound = this.activeRound;
      const round = this.props.rounds.find(i => Number(i.number) === Number(activeRound));
      const roundId = round ? round.id : 0;
      if (roundId) {
        this.setState({ round, roundId }, () => {
          this.loadNavigation(() => {
            this.updateCurrentState();
          });
        });
      }
    }
  }

  get activeRound() {
    const { currentRound, roundInUrl, rounds } = this.props;

    // Sort by round number ascending before picking the last finished
    // one. The BE returns rounds in insertion / id order, not number
    // order — e.g. after Activate Main Rounds the rounds can land in
    // state as (2, 3, 1), which would otherwise make this getter route
    // the instructor to Round 1 instead of the real latest round.
    const finishedRounds = rounds
      .filter(i => i.is_started === true && i.is_finished === true)
      .slice()
      .sort((a, b) => Number(a.number) - Number(b.number));
    const lastFinishedRoundNumber = finishedRounds.length > 0
      ? finishedRounds[finishedRounds.length - 1].number
      : null;

    return Number(roundInUrl || lastFinishedRoundNumber || currentRound);
  }

  loadNavigation(callback) {
    const { roundId } = this.state;
    const { activeRound } = this;

    const game_id = Number(Auth.getGameId());

    batchRequest([
      // Single consolidated call — replaces the paginated
      // /teamgradings/?round=<id> walk (which fired twice for
      // bigger rounds) plus the separate /teamgradings/overall/
      // call inside step1. Returns {teams, count, stats}.
      `${process.env.REACT_APP_API_URL}v2/games/teamgradings/overall/${roundId}/`,
      `${process.env.REACT_APP_API_URL}v2/games/targets/?round_number=${activeRound}&course=${Auth.getCourseId()}`,
      `${process.env.REACT_APP_API_URL}v2/reports/performancefeedbacks/game/${game_id}/?round_number=${activeRound}`,
    ]).then(async res => {
      const overallBody = res[0].body || {};
      const teamGradings = Array.isArray(overallBody.teams) ? overallBody.teams : [];
      const overallCount = overallBody.count || {};
      const overallStats = overallBody.stats || {};
      const teamGradingsLength = Number(overallCount.total_teams) || teamGradings.length;
      const successfulTeamsCount = Number(overallCount.current_weighted_value_eq_1) || 0;
      const gamesTargets = res[1].body;
      const performanceFeedbacksGame = res[2].body;

      // Navigation gating: successful teams = the count returned by
      // the overall endpoint; "why targets weren't hit" = everyone
      // else for this round.
      const showSuccessfulTeams = successfulTeamsCount;
      const showWhyTargetsWerentHit = Math.max(0, teamGradingsLength - successfulTeamsCount);

      const showDesicionsNotSubmitted = !!performanceFeedbacksGame.find(performanceFeedbackGame => performanceFeedbackGame.type === 'Did not submit');
      const showInsufficientCapital = !!performanceFeedbacksGame.find(performanceFeedbackGame => performanceFeedbackGame.type === 'Insufficient capital');

      const showMarketShare = gamesTargets.filter(i => i.market_share > 0).length;
      const showMarketShareStep2 = performanceFeedbacksGame.filter(i => i.type === 'Price range failed').length;
      const showMarketShareStep3 = performanceFeedbacksGame.filter(i => i.type === 'Minimum requirement failed').length;
      const showMarketShareStep4 = performanceFeedbacksGame.filter(i => i.type === 'Product market fit').length;
      const showMarketShareStep5 = performanceFeedbacksGame.filter(i => i.type === 'Awareness').length;
      const showMarketShareStep6 = performanceFeedbacksGame.filter(i => i.type === 'Place').length;
      const showMarketShareStep7 = performanceFeedbacksGame.filter(i => i.type === 'Low inventory').length;
      const showMarketShareStep9 = performanceFeedbacksGame.some(i => i.type === 'Mobile overproduced' || i.type === 'Auto overproduced');

      const showRevenues = gamesTargets.filter(i => i.net_revenues > 0).length;
      const showRevenuesStep2 = performanceFeedbacksGame.filter(i => i.type === 'Expected revenue low').length;
      const showRevenuesStep3 = performanceFeedbacksGame.filter(i => i.type === 'Expected revenue low').length;

      const showGrossMargins = gamesTargets.filter(i => i.gross_margin > 0).length;
      const showGrossMarginsStep2 = performanceFeedbacksGame.filter(i => i.type === 'Gross margin fail').length;
      const showGrossMarginsStep3 = performanceFeedbacksGame.filter(i => i.type === 'Negative gross margins').length;

      const showSharePrices = gamesTargets.filter(i => i.stock_price > 0).length;
      const showSharePricesStep2 = performanceFeedbacksGame.filter(i => i.type === 'Share price fail').length;

      const showROE = gamesTargets.filter(i => i.roe > 0).length;
      const showROEStep2 = performanceFeedbacksGame.filter(i => i.type === 'Roe fail').length;

      const showROA = gamesTargets.filter(i => i.roa > 0).length;
      const showROAStep2 = performanceFeedbacksGame.filter(i => i.type === 'Roa fail').length;

      const showEPS = gamesTargets.filter(i => i.earnings_per_share > 0).length;
      const showEPSStep2 = performanceFeedbacksGame.filter(i => i.type === 'EPS fail').length;

      const currentRoundMetrics = gamesTargets.find(i => Number(i.round_number) === Number(activeRound));
      const metricsToCheck = [
        'roe',
        'roa',
        'earnings_per_share'
      ];

      const netLossMetricsExist = metricsToCheck.some(metric => {
        const value = currentRoundMetrics[metric];
        return value > 0;
      });

      const showNetLoss = performanceFeedbacksGame.filter(i => i.type === 'Negative profits').length && netLossMetricsExist;

      const navigation = [
        {
          title: 'Results Are In!',
          pattern: '/instructor/performance-feedback/results-are-in',
          steps: [
            {
              url: '/instructor/performance-feedback/results-are-in',
              component: ResultsAreInStep1,
            },
            {
              url: '/instructor/performance-feedback/results-are-in/financial-goals',
              component: ResultsAreInStep2,
            },
          ]
        },
        ...(showSuccessfulTeams ? [
          {
            title: 'Successful Teams',
            pattern: '/instructor/performance-feedback/successful-teams',
            steps: [
              ...(activeRound === 1 ? [
                {
                  url: '/instructor/performance-feedback/successful-teams/marketing-mix',
                  component: SuccessfulStep1,
                }
              ] : []),
              ...(activeRound === 2 ? [
                {
                  url: '/instructor/performance-feedback/successful-teams/distribution-centers',
                  component: SuccessfulStep2,
                }
              ] : []),
              ...(activeRound === 3 ? [
                {
                  url: '/instructor/performance-feedback/successful-teams/income-statement',
                  component: SuccessfulStep3,
                }
              ] : []),
            ]
          }
        ] : []),
        ...(showWhyTargetsWerentHit ? [
          {
            title: 'Why Targets Weren\'t Hit',
            pattern: '/instructor/performance-feedback/why-targets-werent-hit',
            steps: [
              {
                url: '/instructor/performance-feedback/why-targets-werent-hit',
                component: WhyTargetsWerentHit,
              }
            ]
          },
          ...(showDesicionsNotSubmitted ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'Decisions not Posted',
              pattern: '/instructor/performance-feedback/decisions-not-submitted',
              steps: [
                {
                  url: '/instructor/performance-feedback/decisions-not-submitted',
                  component: DecisionsNotSubmitted,
                },
              ]
            }
          ] : []),
          ...(showInsufficientCapital ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'Insufficient Capital',
              pattern: '/instructor/performance-feedback/insufficient-capital',
              steps: [
                {
                  url: '/instructor/performance-feedback/insufficient-capital',
                  component: InsufficientCapital,
                },
              ]
            },
          ] : []),
          ...(showMarketShare ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'Market Share',
              pattern: '/instructor/performance-feedback/market-share',
              steps: [
                // {
                //   url: '/instructor/performance-feedback/market-share/class-performance',
                //   component: MarketShareStep1,
                // },
                ...(showMarketShareStep2 ? [
                  {
                    url: '/instructor/performance-feedback/market-share/outside-price-range',
                    component: MarketShareStep2,
                    hasErrorAlert: true,
                  }
                ] : []),
                ...(showMarketShareStep3 ? [
                  {
                    url: '/instructor/performance-feedback/market-share/product-customer-wanted',
                    component: MarketShareStep3,
                    hasErrorAlert: true,
                  }
                ] : []),
                ...(showMarketShareStep4 ? [
                  {
                    url: '/instructor/performance-feedback/market-share/product-met-interest',
                    component: MarketShareStep4,
                    hasErrorAlert: true,
                  }
                ] : []),
                ...(showMarketShareStep5 ? [
                  {
                    url: '/instructor/performance-feedback/market-share/product-promotion',
                    component: MarketShareStep5,
                    hasErrorAlert: true,
                  }
                ] : []),
                ...(showMarketShareStep6 ? [
                  {
                    url: '/instructor/performance-feedback/market-share/sales-channels',
                    component: MarketShareStep6,
                    hasErrorAlert: true,
                  }
                ] : []),
                ...(showMarketShareStep7 ? [
                  {
                    url: '/instructor/performance-feedback/market-share/insufficient-capacity',
                    component: MarketShareStep7,
                    hasErrorAlert: true,
                  }
                ] : []),
                ...(showMarketShareStep9 ? [
                  {
                    url: '/instructor/performance-feedback/market-share/overproduced',
                    component: MarketShareStep9,
                    hasErrorAlert: true,
                  }
                ] : []),
                /*...(activeRound > 1 ? [{
                  url: '/instructor/performance-feedback/market-share/ranking-products',
                  component: MarketShareStep8,
                  hasErrorAlert: true,
                }] : [])*/
              ]
            }
          ] : []),
          ...(showRevenues ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'Revenues',
              pattern: '/instructor/performance-feedback/revenues',
              steps: [
                // {
                //   url: '/instructor/performance-feedback/revenues/class-performance',
                //   component: RevenuesStep1,
                // },
                ...(showRevenuesStep2 ? [
                  {
                    url: '/instructor/performance-feedback/revenues/products-selling-price',
                    component: RevenuesStep2,
                    hasErrorAlert: true,
                  }
                ] : []),
                ...(showRevenuesStep3 ? [
                  {
                    url: '/instructor/performance-feedback/revenues/customers-willingness-to-pay',
                    component: RevenuesStep3,
                    hasErrorAlert: true,
                  }
                ] : []),
              ]
            }
          ] : []),
          ...(showGrossMargins ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'Gross Margins',
              pattern: '/instructor/performance-feedback/gross-margins',
              steps: [
                // {
                //   url: '/instructor/performance-feedback/gross-margins/class-performance',
                //   component: GrossMarginsStep1,
                // },
                ...(showGrossMarginsStep2 ? [
                  {
                    url: '/instructor/performance-feedback/gross-margins/selling-price-too-low',
                    component: GrossMarginsStep2,
                    hasErrorAlert: true,
                  }
                ] : []),
                ...(showGrossMarginsStep3 ? [
                  {
                    url: '/instructor/performance-feedback/gross-margins/running-non-profit',
                    component: GrossMarginsStep3,
                    hasErrorAlert: true,
                  }
                ] : []),
              ]
            }
          ] : []),
          ...(showSharePrices ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'Share Price',
              pattern: '/instructor/performance-feedback/share-price',
              steps: [
                // {
                //   url: '/instructor/performance-feedback/share-price/class-performance',
                //   component: SharePriceStep1,
                // },
                ...(showSharePricesStep2 ? [
                  {
                    url: '/instructor/performance-feedback/share-price/enough-revenues',
                    component: SharePriceStep2,
                    hasErrorAlert: true,
                  }
                ] : [])
              ]
            }
          ] : []),
          ...(showNetLoss ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'Net Loss',
              pattern: '/instructor/performance-feedback/net-loss',
              steps: [
                {
                  url: '/instructor/performance-feedback/net-loss',
                  component: NetLoss,
                  hasErrorAlert: true,
                }
              ]
            }
          ] : []),
          ...(showROE ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'ROE',
              pattern: '/instructor/performance-feedback/roe',
              steps: [
                // {
                //   url: '/instructor/performance-feedback/roe/class-performance',
                //   component: ROEStep1,
                // },
                ...(showROEStep2 ? [
                  {
                    url: '/instructor/performance-feedback/roe/enough-profits',
                    component: ROEStep2,
                    hasErrorAlert: true,
                  }
                ] : [])
              ]
            }
          ] : []),
          ...(showROA ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'ROA',
              pattern: '/instructor/performance-feedback/roa',
              steps: [
                // {
                //   url: '/instructor/performance-feedback/roa/class-performance',
                //   component: ROAStep1,
                // },
                ...(showROAStep2 ? [
                  {
                    url: '/instructor/performance-feedback/roa/enough-profits',
                    component: ROAStep2,
                    hasErrorAlert: true,
                  }
                ] : [])
              ]
            }
          ] : []),
          ...(showEPS ? [
            {
              parent: 'Why Targets Weren\'t Hit',
              title: 'EPS',
              pattern: '/instructor/performance-feedback/eps',
              steps: [
                // {
                //   url: '/instructor/performance-feedback/eps/class-performance',
                //   component: EPSStep1,
                // },
                ...(showEPSStep2 ? [
                  {
                    url: '/instructor/performance-feedback/eps/enough-profits',
                    component: EPSStep2,
                    hasErrorAlert: true,
                  }
                ] : [])
              ]
            }
          ] : []),
        ] : []),
        ...(activeRound === 1 || activeRound === 2 ? [
          {
            title: 'What To Expect Next',
            pattern: '/instructor/performance-feedback/what-to-expect-next',
            steps: [
              {
                url: '/instructor/performance-feedback/what-to-expect-next',
                component: WhatToExpectNext,
              }
            ]
          }
        ] : []),
        ...(activeRound === 1 ? [
          {
            parent: 'What To Expect Next',
            title: 'Supply Chain Decisions',
            pattern: '/instructor/performance-feedback/supply-chain-decisions',
            steps: [
              {
                url: '/instructor/performance-feedback/supply-chain-decisions',
                component: SupplyChainDecisions,
                hasErrorAlert: true,
              }
            ]
          }
        ] : []),
        ...(activeRound === 3 ? [
          {
            parent: 'What To Expect Next',
            title: 'New Scoring Metrics',
            pattern: '/instructor/performance-feedback/new-scoring-metrics',
            steps: [
              {
                url: '/instructor/performance-feedback/new-scoring-metrics',
                component: NewScoringMetrics,
                hasErrorAlert: true,
              }
            ]
          },
          {
            parent: 'What To Expect Next',
            title: 'New Valuation Model',
            pattern: '/instructor/performance-feedback/new-valuation-model',
            steps: [
              {
                url: '/instructor/performance-feedback/new-valuation-model',
                component: NewValuationModel,
                hasErrorAlert: true,
              }
            ]
          },
          {
            parent: 'What To Expect Next',
            title: 'Share Buybacks',
            pattern: '/instructor/performance-feedback/share-buybacks',
            steps: [
              {
                url: '/instructor/performance-feedback/share-buybacks',
                component: ShareBuybacks,
                hasErrorAlert: true,
              }
            ]
          },
        ] : []),
        {
          parent: 'What To Expect Next',
          title: 'Customer Preferences',
          pattern: '/instructor/performance-feedback/customer-preferences',
          steps: [
            {
              url: '/instructor/performance-feedback/customer-preferences',
              component: CustomerPreferences,
              hasErrorAlert: true,
            }
          ]
        },
        ...(activeRound === 1 ? [
          {
            parent: 'What To Expect Next',
            title: 'Product Strategy',
            pattern: '/instructor/performance-feedback/product-strategy',
            steps: [
              {
                url: '/instructor/performance-feedback/product-strategy',
                component: ProductStrategy,
                hasErrorAlert: true,
              }
            ]
          }
        ] : []),
        {
          title: 'That\'s All!',
          pattern: '/instructor/performance-feedback/thats-all',
          steps: [
            {
              url: '/instructor/performance-feedback/thats-all',
              component: ThatsAll,
            }
          ]
        }
      ];

      if (JSON.stringify(navigation) !== JSON.stringify(this.state.navigation)) {
        this.setState({
          navigation,
          teamGradings,
          teamGradingsLength,
          overallStats,
          successfulTeamsCount,
          gamesTargets,
          performanceFeedbacksGame,
          loaded: true,
        }, () => {
          if (callback) {
            callback();
          }
        });
      } else {
        if (callback) {
          callback();
        }
      }
    })
      .catch(err => { console.log(err); });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateCurrentState();
    }
  }

  updateCurrentState = () => {
    const { navigation } = this.state;

    let currentCategory = 0;
    let currentStep = 0;
    for (let i = 0; i < navigation.length; i++) {
      const stepIndex = navigation[i].steps.findIndex(j => j.url === this.props.location.pathname);
      if (stepIndex > -1) {
        currentCategory = i;
        currentStep = stepIndex;
        break;
      }
    }

    if (
      currentCategory !== this.state.currentCategory
      || currentStep !== this.state.currentStep
    ) {

      this.setState({
        currentCategory,
        currentStep,
      }, () => {
        this.checkLocation();
      });
    } else {
      if (this.props.location.pathname === '/performance-feedback') {
        this.checkLocation();
      }
    }
  }

  checkLocation = () => {
    const { currentCategory, currentStep, navigation } = this.state;
    const activeRound = this.activeRound;

    if (this.props.location.pathname !== navigation[currentCategory].steps[currentStep].url) {
      changeLocation(`${navigation[currentCategory].steps[currentStep].url}?round=${activeRound}`);
    }
  }

  goNext = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let nextCategory = currentCategory;
    let nextStep = currentStep + 1;
    if (nextStep >= navigation[currentCategory].steps.length) {
      nextCategory = currentCategory + 1;
      nextStep = 0;

      if (nextCategory >= navigation.length) {
        return false;
      } else if (nextStep >= navigation[nextCategory].steps.length) {
        nextCategory = currentCategory + 2;
        nextStep = 0;

        if (nextCategory >= navigation.length) {
          return false;
        }
      }
    }

    this.setState({
      currentCategory: nextCategory,
      currentStep: nextStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  goPrev = e => {
    e.preventDefault();

    const { currentCategory, currentStep, navigation } = this.state;

    let prevCategory = currentCategory;
    let prevStep = currentStep - 1;
    if (prevStep < 0) {
      prevCategory = currentCategory - 1;
      if (prevCategory < 0) {
        return false;
      }

      prevStep = navigation[prevCategory].steps.length - 1;
      if (prevStep < 0) {
        prevCategory = currentCategory - 2;
        if (prevCategory < 0) {
          return false;
        }

        prevStep = navigation[prevCategory].steps.length - 1;
      }
    }

    this.setState({
      currentCategory: prevCategory,
      currentStep: prevStep,
    }, () => {
      this.checkLocation();
    });

    return false;
  }

  get isFirstStep() {
    const { currentCategory, currentStep } = this.state;

    return currentCategory === 0 && currentStep === 0;
  }

  get isLastStep() {
    const { currentCategory, currentStep, navigation } = this.state;

    const lastCategory = navigation.length - 1;
    const lastStep = navigation[lastCategory].steps.length - 1;

    return currentCategory === lastCategory && currentStep === lastStep;
  }

  get countOfSteps() {
    const { currentCategory, navigation } = this.state;

    return navigation[currentCategory].steps.length;
  }

  render() {
    const {
      currentCategory,
      currentStep,
      navigation,
      loaded,
      teamGradings,
      teamGradingsLength,
      overallStats,
      successfulTeamsCount,
      gamesTargets,
      roundId,
      performanceFeedbacksGame
    } = this.state;
    const { rounds } = this.props;
    const activeRound = this.activeRound;

    if (navigation.length === 0 || !loaded) {
      return (
        <Wrapper>
          <Loader type="ball-scale-ripple" active />
        </Wrapper>
      );
    }

    // Guard: hide the whole page when the active round hasn't closed.
    // The activeRound getter honors ?round=N in the URL, which can land
    // the instructor on a live or not-yet-started round. In that case
    // the BE still returns teamgradings / performancefeedbacks (often
    // mirroring the prior round), which would mislead the instructor
    // into thinking the current round's results are in. Replace the
    // page with a status message until is_finished flips to true.
    const activeRoundRecord = rounds.find(
      i => Number(i.number) === Number(activeRound)
    );
    const roundIsFinished = activeRoundRecord
      && activeRoundRecord.is_finished === true;
    if (!roundIsFinished) {
      const roundStarted = activeRoundRecord
        && activeRoundRecord.is_started === true;
      const headline = roundStarted
        ? "Round has not closed yet."
        : "Round has not started yet.";
      const subtext = roundStarted
        ? "Performance feedback will appear here once the round closes."
        : "Performance feedback will appear here once the round starts and closes.";
      return (
        <Wrapper>
          <EmptyState>
            <EmptyStateTitle>{headline}</EmptyStateTitle>
            <EmptyStateSubtext>{subtext}</EmptyStateSubtext>
          </EmptyState>
        </Wrapper>
      );
    }

    const category = navigation[currentCategory];
    let Component = null;
    let previousShownErrors = 0;
    if (category) {
      Component = category.steps[currentStep].component;

      const url = category.steps[currentStep].url;
      const allSteps = navigation.reduce((prev, curr) => ([
        ...prev,
        ...curr.steps,
      ]), []);
      const currentStepIndex = allSteps.findIndex(i => i.url === url);
      previousShownErrors = allSteps.slice(0, currentStepIndex).filter(i => i.hasErrorAlert === true).length;
    }

    return (
      <Wrapper>
        <Navigation
          data={navigation}
          category={currentCategory}
          activeRound={activeRound}
        />
        <Content>
          <ContentWrapper>
            {Component && (
              <Component
                activeRound={activeRound}
                rounds={rounds}
                previousShownErrors={previousShownErrors}
                teamGradings={teamGradings}
                teamGradingsLength={teamGradingsLength}
                overallStats={overallStats}
                successfulTeamsCount={successfulTeamsCount}
                gamesTargets={gamesTargets}
                performanceFeedbacksGame={performanceFeedbacksGame}
                roundId={roundId}
              />
            )}
          </ContentWrapper>
          <Pagination
            goNext={this.goNext}
            goPrev={this.goPrev}
            isFirstStep={this.isFirstStep}
            isLastStep={this.isLastStep}
            currentStep={currentStep + 1}
            countOfSteps={this.countOfSteps}
          />
        </Content>
      </Wrapper>
    );
  }

}

export default InstructorPerformanceFeedback;



// WEBPACK FOOTER //
// ./src/instructor/containers/performance-feedback.js